import { Box, Tab, Tabs, WithStyles } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import * as React from "react";
import { styles } from "../ProductDetailsCheckoutContent.styles";
import { KaikoProductDetailsHistoricalBox } from "./KaikoProductDetailsHistoricalBox";
import { ISubscriptionType, KaikoProductDetailsSubscriptionBox } from "./KaikoProductDetailsSubscriptionBox";

interface TabPanelProps {
    children?: React.ReactNode;
    index: any;
    value: any;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`product-details-tabpanel-${index}`}
            aria-labelledby={`product-details-tab-${index}`}
            {...other}
        >
            {value === index && <Box p={0}>{children}</Box>}
        </div>
    );
}

export interface IKaikoProductDetailsCheckoutContentProps extends WithStyles<typeof styles> {
    product: string;
    otpEnabled: boolean;
    subscriptionEnabled: boolean;
    isAlreadySubscribed: boolean;
    subscriptionTypes: ISubscriptionType[];
    firstAvailableDate: string;
    lastAvailableDate: string;
    onCheckout: any;
}

const KaikoProductDetailsCheckoutContentPure: React.FunctionComponent<IKaikoProductDetailsCheckoutContentProps> = ({
    product,
    otpEnabled,
    subscriptionEnabled,
    isAlreadySubscribed,
    subscriptionTypes,
    firstAvailableDate,
    lastAvailableDate,
    onCheckout,
    classes
}: IKaikoProductDetailsCheckoutContentProps) => {
    const [value, setValue] = React.useState(0);
    const tabs = [
        { title: "One-off order", isAvailable: otpEnabled },
        { title: "Subscription", isAvailable: subscriptionEnabled }
    ];

    const isBothOptions = otpEnabled && subscriptionEnabled;

    return (
        <>
            <Box>
                {isBothOptions && (
                    <Tabs
                        value={value}
                        indicatorColor="primary"
                        textColor="primary"
                        onChange={(e, newValue) => setValue(newValue)}
                    >
                        {tabs
                            .filter(tab => tab.isAvailable)
                            ?.map((tab, index) => (
                                <Tab key={index} label={tab.title} />
                            ))}
                    </Tabs>
                )}
                <TabPanel value={value} key={0} index={0}>
                    {otpEnabled ? (
                        <KaikoProductDetailsHistoricalBox
                            product={product}
                            firstAvailableDate={firstAvailableDate}
                            lastAvailableDate={lastAvailableDate}
                            onCheckout={onCheckout}
                        />
                    ) : null}
                </TabPanel>
                <TabPanel value={value} key={1} index={1}>
                    {subscriptionEnabled ? (
                        <KaikoProductDetailsSubscriptionBox
                            product={product}
                            isAlreadySubscribed={isAlreadySubscribed}
                            subscriptionTypes={subscriptionTypes}
                        />
                    ) : null}
                </TabPanel>
            </Box>
        </>
    );
};

export const KaikoProductDetailsCheckoutContent = withStyles(styles)(KaikoProductDetailsCheckoutContentPure);
